import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-navigate-back-btn',
  templateUrl: './navigate-back-btn.component.html',
  styleUrls: ['./navigate-back-btn.component.scss'],
})
export class NavigateBackBtnComponent {
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();
  onButtonClick(): void {
    this.buttonClicked.emit();
  }
}
